import { render, staticRenderFns } from "./sbsp-file-upload.vue?vue&type=template&id=f97048f2&scoped=true&"
import script from "./sbsp-file-upload.vue?vue&type=script&lang=js&"
export * from "./sbsp-file-upload.vue?vue&type=script&lang=js&"
import style0 from "./sbsp-file-upload.vue?vue&type=style&index=0&id=f97048f2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f97048f2",
  null
  
)

export default component.exports